import React, { useState, useEffect } from "react";
import { FormGroup, ControlLabel, FormControl, Button } from "react-bootstrap";
import * as API from '../../../api/billing'

const BillPartPayment = ({ row, handleClosePartPaymentModal }) => {
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [billNo, setBillNo] = useState("");
  const [btnClicked, setBtnClicked] = useState(false)

  const safeNumber = (val) => {
    const num = Number(val);
    return isNaN(num) ? 0 : num;
  };

  const handleSave = async () => {
    setBtnClicked(true);
    try {
      const payload = {
        billNumber: row?.billNumber || "",
        patientId: row?.patientId || "",
        totalAmount: row?.totalAmount || "",
        totalPaidAmount: (safeNumber(row?.totalPaidAmount) + safeNumber(paymentAmount)).toString(),
        totalDiscountAmount: row?.totalDiscountAmount || "",
        totalRemainingAmount: (safeNumber(row?.totalRemainingAmount) - safeNumber(paymentAmount)).toString(),
        services: row?.services ? JSON.stringify(row.services) : "[]",
        installmentAmount: safeNumber(paymentAmount).toString()
      };

      let resp = await API.recoveryBill(payload);
      if (resp?.data?.status === "Success" && resp?.data?.statusCode) {
        handleClosePartPaymentModal("updateBill");
      }
    } catch (error) {
      // Optionally handle error (e.g., show notification)
      console.error("Error saving part payment:", error);
    } finally {
      setBtnClicked(false);
    }
  };

  useEffect(() => {
    if (row) {
      setBillNo(row?.billNumber);
      const patientDetail = {
        firstName: row?.patientData?.firstName,
        lastName: row?.patientData?.lastName,
        patientClinicId: row?.patientData?.patientClinicId
      };
      setSelectedPatient(patientDetail);
    }
  }, [row]);

  // Helper to display amounts with ₹ only if > 0
  const formatAmount = (amount) => {
    if (!amount || amount === "0" || amount === 0) return "";
    return `₹${amount}`;
  };

  // Validation state
  const [error, setError] = useState("");

  // Validate paymentAmount before saving
  const validateAndSave = () => {
    const remaining = safeNumber(row?.totalRemainingAmount);
    const entered = safeNumber(paymentAmount);

    if (entered <= 0) {
      setError("Please enter a valid amount greater than 0.");
      return;
    }
    if (entered > remaining) {
      setError("Payment amount cannot be greater than remaining amount.");
      return;
    }
    setError("");
    handleSave();
  };

  return (
    <div style={{ fontFamily: "Arial", padding: 20 }}>

      {/* Patient Details Strip */}
      {selectedPatient && (
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          border: "1px solid #ddd",
          padding: "15px 20px",
          borderRadius: 8,
          marginBottom: 20,
          backgroundColor: "#f9f9f9",
          fontWeight: "bold"
        }}>
          <div>Bill No: {billNo}</div>
          <div>Patient Name: {selectedPatient.firstName} {selectedPatient.lastName}</div>
          <div>Patient ID: {selectedPatient.patientClinicId}</div>
        </div>
      )}

      {/* Amount Summary Box */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        border: "1px solid #ddd",
        padding: "15px 20px",
        borderRadius: 8,
        marginBottom: 20,
        backgroundColor: "#eef2f7",
        fontWeight: "bold"
      }}>
        <div>Total Amount: {formatAmount(row?.totalAmount)}</div>
        <div>Total Paid: {formatAmount(row?.totalPaidAmount)}</div>
        <div>Total Discount: {formatAmount(row?.totalDiscountAmount)}</div>
        <div style={{ color: row?.totalRemainingAmount > 0 ? "red" : "black" }}>
          Remaining: {formatAmount(row?.totalRemainingAmount)}
        </div>
      </div>

      {/* Payment Details Box */}
      <div style={{
        border: "1px solid #ddd",
        padding: "15px 20px",
        borderRadius: 8,
        display: "flex",
        alignItems: "center",
        gap: "15px"
      }}>
        <FormGroup controlId="paymentAmount" style={{ flex: 1, marginBottom: 0 }}>
          <ControlLabel>Enter Amount</ControlLabel>
          <FormControl
            type="number"
            value={paymentAmount}
            placeholder="Enter payment amount"
            onChange={(e) => {
              setPaymentAmount(e.target.value);
              setError(""); // Clear error on change
            }}
          />
          {error && (
            <div style={{ color: "red", marginTop: 5, fontSize: 13 }}>
              {error}
            </div>
          )}
        </FormGroup>

        <Button bsStyle="success" onClick={validateAndSave} style={{ marginTop: 24 }} disabled={btnClicked}>
          <span>
            Save{" "}
            {btnClicked && <i className="fa fa-spinner fa-spin"></i>}
          </span>
        </Button>
      </div>
    </div>
  );
};

export default BillPartPayment;
